<template>
    <div>
        <app-bar>
            <template #title> {{ merchantDetails.name }} </template>
            <template #status>
                <div class="rounded text-center mx-4 font-weight-medium text-caption py-1 px-4" :class="['status', merchantDetails.status.toLowerCase()]">{{ merchantDetails.status | uppercaseFirst }}</div>
            </template>
            <template v-if="(merchantDetails.schedule || {}).hasScheduledSetting" #subtitle>
                <ActivationSetting />
            </template>
            <template #actionBtns>
                <v-btn class="mx-1" outlined text :to="navigation('to', ['edit', id])"><v-icon small>mdi-square-edit-outline</v-icon>Edit Branch</v-btn>
                <v-btn color="primary" class="mx-1 disabled">Save</v-btn>
            </template>
            <template #navigationTabs>
                <v-tabs class="tabs ml-8" :v-model="activeTab">
                    <v-tab :to="$route.path">Details</v-tab>
                </v-tabs>
            </template>
        </app-bar>
        <v-container fluid>
            <QRDetails />
        </v-container>
    </div>
</template>

<script>
import AppBar from '@/components/Core/AppBar.vue';
import ActivationSetting from '@/components/Merchant/ActivationSetting.vue';
import QRDetails from '@/components/Core/QRDetails.vue';

export default {
    name: 'ViewMerchant',
    components: {
        AppBar,
        ActivationSetting,
        QRDetails
    },
    data() {
        return {
            activeTab: ''
        };
    },
    computed: {
        id() {
            return this.$route.params.branch ? this.$route.params.branch : this.$route.params.id;
        },
        merchantDetails() {
            return { status: '', ...this.$store.getters['merchants/getMerchantDetails'] };
        }
    },
    mounted() {
        this.$store.commit('merchants/SET_MERCHANT_DETAILS', {});
        this.$store
            .dispatch('merchants/findMerchant', {
                id: this.id,
                config: {
                    params: {
                        appends: ['primary_merchant', 'qr_base64']
                    }
                }
            })
            .catch(() => {
                this.$router.push(this.navigation('back'));
            });
    }
};
</script>
